import React, { Component } from 'react';
import './App.css';
import { graphql, compose } from 'react-apollo'
import gql from 'graphql-tag'
import { Button, Card, Image, Grid, Popup } from 'semantic-ui-react'
import moment from 'moment'


import UserFullname from './users/UserFullname'
import UserAvatar from './users/UserAvatar'
import OrganisationLogo from './organisations/OrganisationLogo'
import OrganisationName from './organisations/OrganisationName'
import DiscoveryItemCard from './DiscoveryItemCard'


const baseCdnUrl = window.location.hostname === 'discovery.brikl.io' ? 'https://cdn.discovery.brikl.io' : 'https://staging.cdn.discovery.brikl.io'    
const appUrl = window.location.hostname === 'discovery.brikl.io' ? 
  'https://app.brikl.io' : 
  window.location.hostname === 'staging.discovery.brikl.io' ? 'https://staging.app.brikl.io' : 'http://localhost:8080'


function parse_query_string(query) {  
  var vars = query.split("&");
  var query_string = {};
  for (var i = 0; i < vars.length; i++) {
      var pair = vars[i].split("=");
      // If first entry with this name
      if (typeof query_string[pair[0]] === "undefined") {
      query_string[pair[0]] = decodeURIComponent(pair[1]);
      // If second entry with this name
      } else if (typeof query_string[pair[0]] === "string") {
      var arr = [query_string[pair[0]], decodeURIComponent(pair[1])];
      query_string[pair[0]] = arr;
      // If third or later entry with this name
      } else {
      query_string[pair[0]].push(decodeURIComponent(pair[1]));
      }
  }
  // alert(
  //   JSON.stringify(query_string)
  // )
  return query_string;
}

class Home extends Component {
  static propTypes = { 
    // history: React.PropTypes.object.isRequired,      
  } 
  state = { 
    modalOpen: false, 
    activeItem: 'gamepad',
    itemname: '',
    organisationid: '',
    userid: '',
    boardid: '',
    suppliers: null,
    colors: null,
    ownedby: ''
  } 
  

  handleItemClick = (e, { name }) => this.setState({ activeItem: name })
  handleOpen = () => this.setState({ modalOpen: true })
  handleClose = () => this.setState({ modalOpen: false })

  Hit = ({hit}) => {
    return (<div className="hit">
      <div className="hit-image">
        <img alt={hit.title} src={baseCdnUrl+ '/' + hit.boardid + '/public/screen.jpg'}/>
      </div>
      <div className="hit-content">
        <h3>{hit.title}</h3>
        <div className="hit-color">{hit.colorList}</div>
        <div className="hit-category">{hit.categoryList}</div>
      </div>
    </div>);
  }



  render() {
    

    if (this.props.DiscoveryQuery.loading) {      
      return (
          <div className="">                            
              <Grid className="card--list" doubling columns="4">
                <Grid.Column stretched>
                  <Card>
                    <Card.Header textAlign="left">
                      <Card.Meta>
                        <h4 className="placeholder">&nbsp;</h4>
                        <div className="orgitem placeholder">
                        </div>
                      </Card.Meta>
                    </Card.Header>

                    <Image alt=" " src="https://cdn.brikl.io/app/loading/placeholder.png" className="placeholder" />
                    
                    <Card.Content textAlign="left">
                      <Grid>
                        <Grid.Column width={15}>  
                        <img alt=" " src="https://cdn.brikl.io/app/loading/placeholder.png" className="user--profile__img placeholder" />          
                      
                      <span className="user--name placeholder">
                      &nbsp;                    
                      <br/>
                      </span>
                        </Grid.Column>
                          
                      </Grid>
                    </Card.Content>
                  </Card>
                </Grid.Column>
                <Grid.Column stretched>
                  <Card>
                    <Card.Header textAlign="left">
                      <Card.Meta>
                        <h4 className="placeholder">&nbsp;</h4>
                        <div className="orgitem placeholder">
                        </div>
                      </Card.Meta>
                    </Card.Header>

                    <Image alt=" " src="https://cdn.brikl.io/app/loading/placeholder.png" className="placeholder" />
                    
                    <Card.Content textAlign="left">
                      <Grid>
                        <Grid.Column width={15}>  
                          <img alt=" " src="https://cdn.brikl.io/app/loading/placeholder.png" className="user--profile__img placeholder" />
                          <span className="user--name placeholder">
                          &nbsp;                    
                          <br/>
                          </span>
                        </Grid.Column>
                      
                          
                      </Grid>
                    </Card.Content>
                  </Card>
                </Grid.Column>
              </Grid>
          </div>
      )
    }    
    const DiscoveryItems = this.props.DiscoveryQuery.discovery ? this.props.DiscoveryQuery.discovery : []
    const discoveryList = []
    DiscoveryItems.forEach((item, i) =>{
      const myitem = item
      try {
        
        var orgItems = []
        var orgArray = myitem.supplierList.split(',')
        orgArray.forEach(org => {
          const orgid = org
          orgItems.push(
            <div className="orgitem" key={orgid}>
              {/* <OrganisationLogo organisationid={orgid} />  */}
              <OrganisationName organisationid={orgid} /> 
              {/* <a href=""><Icon name="info circle"/></a>              */}
            </div>
          )
        });

        var colorItems = []
        var colorArray = myitem.colorList.split(',')
        colorArray.forEach(color => {
          const colorid = color
          if(color.indexOf('#')!==-1){
            var divStyle = {
              background: colorid
            };
            colorItems.push(
              <div 
                onClick={
                  ()=>{
                    this.handleClose()
                    this.props.history.push('/?color='+encodeURIComponent(colorid) )
                    this.props.DiscoveryQuery.refetch()
                  }
                }
                key={colorid} className="coloritem" style={divStyle}
              ></div>
            )
          }          
        });
      } catch (error) {
        
      }
      discoveryList.push(
      <Grid.Column stretched>
        <Card onClick={()=>{
          this.setState({
            boardid: myitem.boardid,
            ownedby: myitem.ownedby,
            itemname: myitem.title,
            title: myitem.title,
            suppliers: orgItems,
            colors: colorItems
          })
            this.handleOpen()
          }}>
          <Card.Header textAlign="left">
            <Card.Meta>
              <h4>{myitem.title}</h4>
              {orgItems}      
            </Card.Meta>
          </Card.Header>

          <Image src={baseCdnUrl+ '/' + myitem.boardid + '/public/screen.jpg'} />
          
          <Card.Content textAlign="left">
            <Grid>
              <Grid.Column computer={8} className="card--footer" mobile="16">  
              {
                myitem.ownedby.indexOf('auth') !== -1 ?
                <UserAvatar userid={myitem.ownedby} className="user--profile__img" />
                :
                <OrganisationLogo organisationid={myitem.ownedby} className="user--profile__img" />
              }          
            
            <span className="user--name">
            {
              myitem.ownedby.indexOf('auth') !== -1 ?
              <UserFullname userid={myitem.ownedby} />
              :
              <OrganisationName organisationid={myitem.ownedby} />
            }
            <br/>
            <span className="timestamp hidden">{moment(myitem.createdAt).fromNow()}</span>
            </span>
              </Grid.Column>
              <Grid.Column computer={8} className="colors--section" mobile="16">  
                {colorItems}                        
              </Grid.Column>
              {/* <Grid.Column computer={16} className="socials--items" mobile="16">  
                                   
              </Grid.Column> */}

                <Popup
                  trigger={<Button onClick={()=>{
                    window.open(appUrl+'/discovery/copy/board/'+myitem.boardid+'?referal=discovery&discoveryitem='+myitem.boardid)
                  }} size="mini" icon="external" content="BrikL"/>}
                  position='bottom right'
                >
                  <p>Click here to open the designs in BrikL's fashion Design Studio. </p>

                  <p>Unleash your creativity: Customise the designs and share back on BrikL Discovery.</p>

                  <p>Get your design made: Connect directly with the manufacturer through BrikL.</p>

                  <p>BrikL is a B2B Collaborative Fashion Design Platform.</p>

                </Popup>
            </Grid>
          </Card.Content>
        </Card>
      </Grid.Column>
      )
    })


    return (
        <div>
          {
            parse_query_string( window.location.search.substring(1) ).color ?
            <h2>Filtered by color: <span className="colorItem">{parse_query_string( window.location.search.substring(1) ).color}</span></h2>
            :
            parse_query_string( window.location.search.substring(1) ).category ?
            <h2>Filtered by category: {parse_query_string( window.location.search.substring(1) ).category}</h2>
            :
            parse_query_string( window.location.search.substring(1) ).ownedby ?
            <h2>Filtered by author: {parse_query_string( window.location.search.substring(1) ).ownedby}</h2>
            :
            parse_query_string( window.location.search.substring(1) ).supplier ?
            <h2>Filtered by supplier: {parse_query_string( window.location.search.substring(1) ).supplier}</h2>
            :
            null
          }
          <Grid className="card--list" doubling columns="4">
              {
                discoveryList && discoveryList.length ?
                discoveryList
                : <div>No results found</div>
              }
          </Grid>
          <DiscoveryItemCard parent={this} item={this.state} />          
      </div>
    );
  }
}



const discovery = gql`
query discovery(
  $color: String
  $ownedby: String
  $category: String
  $supplier: String
  ){
  discovery(
    color: $color
    ownedby: $ownedby
    category: $category
    supplier: $supplier
  ){
    title
    boardid
    ownedby
    publishedby
    supplierList
    colorList
    categoryList
    createdAt
    updatedAt
    cacheHit
  }  
}`


const HomeWithData = compose(
 graphql(
  discovery, {
    name: 'DiscoveryQuery',
    options: (ownProps) => ({
      variables: {
          color: parse_query_string( window.location.search.substring(1) ).color ? parse_query_string( window.location.search.substring(1) ).color : null,
          ownedby: parse_query_string( window.location.search.substring(1) ).author ? parse_query_string( window.location.search.substring(1) ).author : null,
          category: parse_query_string( window.location.search.substring(1) ).category ? parse_query_string( window.location.search.substring(1) ).category : null,
          supplier: parse_query_string( window.location.search.substring(1) ).supplier ? parse_query_string( window.location.search.substring(1) ).supplier : null
      },
      operation: 'query',
    })
  }
),  
 )(Home)
 
 export default HomeWithData



// WEBPACK FOOTER //
// ./src/Home.js